import { render, staticRenderFns } from "./PaymentsTable.vue?vue&type=template&id=471e5536&scoped=true&"
import script from "./PaymentsTable.vue?vue&type=script&lang=js&"
export * from "./PaymentsTable.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsTable.vue?vue&type=style&index=0&id=471e5536&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471e5536",
  null
  
)

export default component.exports